import {UxConfig} from "./deviceFeatureSets/uxConfig/uxConfig";
import {UxConfigAsMap} from "./deviceFeatureSets/uxConfigAsMap/uxConfigAsMap";
import {DeviceOp} from "./deviceFeatureSets/deviceOp/deviceOp";
import {Cached} from "./deviceFeatureSets/cached/cached";
import {DeviceMapping} from "./deviceFeatureSets/deviceMapping";
import {Backups} from "./deviceFeatureSets/backups/backups";

export class DeviceFeatureSets {
    constructor() {
        this.uxConfig = new UxConfig();
        this.uxConfigAsMap = new UxConfigAsMap();
        this.cached = new Cached();
        this.deviceOp = new DeviceOp();
        this.deviceMapping = new DeviceMapping();
        this.backups = new Backups();
    }
}
